var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// 网络类型定义
var NetType;
(function (NetType) {
    NetType[NetType["WIFI"] = 1] = "WIFI";
    NetType[NetType["2G"] = 2] = "2G";
    NetType[NetType["3G"] = 3] = "3G";
    NetType[NetType["4G"] = 4] = "4G";
    NetType[NetType["5G"] = 5] = "5G";
    NetType[NetType["MOBILE"] = 6] = "MOBILE";
    NetType[NetType["ETHERNET"] = 7] = "ETHERNET";
    NetType[NetType["OTHER"] = 8] = "OTHER";
})(NetType || (NetType = {}));
// 事件类型定义
var EventType;
(function (EventType) {
    EventType[EventType["EXPOSE"] = 1001] = "EXPOSE";
    EventType[EventType["CLICK"] = 1002] = "CLICK";
    EventType[EventType["EXIT"] = 1003] = "EXIT";
    EventType[EventType["DELETE"] = 1004] = "DELETE";
    EventType[EventType["ADD"] = 1005] = "ADD";
    EventType[EventType["MOVE"] = 1006] = "MOVE";
})(EventType || (EventType = {}));
// 系统类型定义
var SysId;
(function (SysId) {
    SysId[SysId["ANDROID"] = 1] = "ANDROID";
    SysId[SysId["IOS"] = 2] = "IOS";
    SysId[SysId["PC"] = 3] = "PC";
})(SysId || (SysId = {}));
var ProductId;
(function (ProductId) {
    ProductId[ProductId["XINYUE"] = 1] = "XINYUE";
    ProductId[ProductId["XIAOYUE"] = 2] = "XIAOYUE";
    ProductId[ProductId["SVIP"] = 3] = "SVIP";
    ProductId[ProductId["CIEBA"] = 4] = "CIEBA";
    ProductId[ProductId["HELPER"] = 5] = "HELPER";
})(ProductId || (ProductId = {}));
var DataSource;
(function (DataSource) {
    DataSource[DataSource["NATIVE_APP"] = 1] = "NATIVE_APP";
    DataSource[DataSource["PC"] = 2] = "PC";
    DataSource[DataSource["INSIDE"] = 3] = "INSIDE";
    DataSource[DataSource["WECHART_OFFICIAL_WEBSITE"] = 4] = "WECHART_OFFICIAL_WEBSITE";
    DataSource[DataSource["H5_APP"] = 21] = "H5_APP";
    DataSource[DataSource["H5_MOBILE"] = 12] = "H5_MOBILE";
    DataSource[DataSource["H5_PC"] = 22] = "H5_PC";
    DataSource[DataSource["H5_WX_ACCOUNT"] = 11] = "H5_WX_ACCOUNT";
    DataSource[DataSource["H5_WX_MP"] = 23] = "H5_WX_MP";
    DataSource[DataSource["H5_QQ_ACCOUNT"] = 10] = "H5_QQ_ACCOUNT";
    DataSource[DataSource["H5_QQ_MP"] = 24] = "H5_QQ_MP";
    DataSource[DataSource["OTHER"] = 0] = "OTHER";
})(DataSource || (DataSource = {}));
// 登录类型
var LoginType;
(function (LoginType) {
    LoginType[LoginType["QQ"] = 1] = "QQ";
    LoginType[LoginType["WX"] = 2] = "WX";
    LoginType[LoginType["QC"] = 3] = "QC";
})(LoginType || (LoginType = {}));

// 元素曝光类
var IO = /*@__PURE__*/ (function () {
    function IO(options) {
        if (options === void 0) { options = {}; }
        // 单例
        if (typeof IO.instance === 'object') {
            return IO.instance;
        }
        IO.instance = this;
        this.STAY_TIME = options.stayTime || 2000; // 停留多长时间才算有效曝光
        this.io = new IntersectionObserver(this.callback.bind(this), options);
        this.elements = new WeakMap();
    }
    /**
     * 添加监听元素
     * @param {Element}  element  将要进行监听的元素
     * @param {Function} callback 被监听的元素进入可视区一定时间后触发该回调
     * @param {Boolean}  once     是否只监听一次
     */
    IO.prototype.add = function (element, callback, once) {
        if (once === void 0) { once = false; }
        if (!this.elements.has(element)) {
            this.io.observe(element);
            this.elements.set(element, [
                {
                    callback: callback,
                    once: once,
                },
            ]);
        }
        else {
            var ele = this.elements.get(element);
            ele.push({
                callback: callback,
                once: once,
            });
        }
    };
    IO.prototype.callback = function (entries) {
        var _this = this;
        entries.forEach(function (entry) {
            var container = entry.target;
            var ele = _this.elements.get(container);
            if (!ele || ele.length < 0)
                return;
            if (entry.intersectionRatio > 0) {
                // 元素进入可视区
                ele.timer = setTimeout(function () {
                    var clean = true;
                    ele.forEach(function (item) {
                        if (item.callback)
                            item.callback();
                        if (item.once) {
                            Object.assign(item, { callback: null });
                        }
                        // 只要有一个不能清理，则继续保持监听
                        if (clean && !item.once) {
                            clean = false;
                        }
                    });
                    if (clean)
                        _this.io.unobserve(container);
                }, _this.STAY_TIME);
            }
            else {
                // 元素不可见，不再计算时间
                clearTimeout(ele.timer);
            }
        });
    };
    return IO;
}());

var pluginExpose = function (probe, options) {
    try {
        var io_1 = new IO(options);
        // 追踪曝光事件
        var expose = function (element, message, once) {
            io_1.add(element, function () {
                probe.report(__assign({ event_type: EventType.EXPOSE }, message));
            }, once);
        };
        probe.expose('expose', expose);
    }
    catch (err) {
        // TODO. 兼容低版本浏览器
        probe.expose('expose', function () { });
    }
};

export { pluginExpose as default };
